import { render } from "./PaymentSlipPageList.vue?vue&type=template&id=7c9dc0f5&scoped=true"
import script from "./PaymentSlipPageList.vue?vue&type=script&lang=ts"
export * from "./PaymentSlipPageList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-7c9dc0f5"

export default script